export const getStepRequestId = (stepId, entityTypeFilter = null) => {
  return entityTypeFilter
    ? `step-${stepId}-${entityTypeFilter}`
    : `step-${stepId}`;
};
